import config from './config'
import axios from 'axios'

var qs = require('qs')
import aes from '../../static/public'

export const getRecruit = (data) => {
  return axios.post(config.getRecruit, createPostParams(data))
}
export const auth_url = (data) => {
  return axios.post(config.auth_url, createPostParams(data))
}
export const get_contact = (data) => {
  return axios.post(config.get_contact, createPostParams(data))
}
export const share_s = (data) => {
  return axios.post(config.share_s, createPostParams(data))
}
export const showCates = (data) => {
  return axios.post(config.showCates, createPostParams(data))
}
export const getSignPackage = (data) => {
  return axios.post(config.getSignPackage, createPostParams(data))
}
export const getDetail = (data) => {
  return axios.post(config.getDetail, createPostParams(data))
}
export const getList = (data) => {
  return axios.post(config.getList, createPostParams(data))
}
export const getLove = (data) => {
  return axios.post(config.getLove, createPostParams(data))
}
export const getSlider = (data) => {
  return axios.post(config.getSlider, createPostParams(data))
}
export const getUserinfo = (data) => {
  return axios.post(config.getUserinfo, createPostParams(data))
}
export const getInformationDetail = (data) => {
  return axios.post(config.getInformationDetail, createPostParams(data))
}
export const getInformationInfoByPage = (data) => {
  return axios.post(config.getInformationInfoByPage, createPostParams(data))
}
export const mediaIncre = (data) => {
  return axios.post(config.mediaIncre, createPostParams(data))
}

/*
 * 创建Post x-www-form-urlencode请求参数
 * */
function createPostParams (obj) {
  return qs.stringify(aes.selfEncrypt(obj))
}



// WEBPACK FOOTER //
// ./src/api/index.js